import React from 'react';
import { motion } from 'framer-motion';

interface StreakEntryProps {
  title: string;
  period: string;
  days: number;
  streakCount: number;
  dashed?: boolean;
  isLast?: boolean;
  index?: number;
}

const streakColors = {
  0: 'bg-[#8364FF]', // Purple for first streak
  1: 'bg-[#FF64B1]', // Pink for second streak
  2: 'bg-[#64FFB1]'  // Mint for third streak
};

export const StreakEntry: React.FC<StreakEntryProps> = ({ 
  title, 
  period, 
  days, 
  streakCount,
  dashed = false,
  isLast = false,
  index = 0
}) => {
  const streakColor = streakColors[index as keyof typeof streakColors] || 'bg-[#8364FF]';

  return (
    <div className={`${!isLast ? 'border-b border-[#221A51]/10' : ''}`}>
      <div className={`${index === 0 ? 'pt-4' : 'pt-8'} pb-8 space-y-6`}>
        <div className="space-y-2">
          <div className="text-lg sm:text-xl md:text-2xl font-bold text-[#221A51]">
            {title}
          </div>
          <div className="text-sm sm:text-base text-[#221A51]/60">
            Period: {period}
          </div>
        </div>

        <div className="inline-block bg-[#1A1425] rounded-lg px-4 py-2">
          <div className="flex items-center space-x-1.5">
            <span className="text-xl sm:text-2xl md:text-3xl text-[#9BFFA9] font-mono font-bold">
              {days}
            </span>
            <span className="text-xs sm:text-sm text-white/60">days</span>
          </div>
        </div>

        <div className="flex gap-2">
          {Array.from({ length: streakCount }).map((_, i) => (
            <motion.div
              key={i}
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ 
                delay: i * 0.05,
                type: "spring",
                stiffness: 400,
                damping: 10
              }}
              className={`h-2.5 sm:h-3 rounded-full ${
                dashed 
                  ? 'w-5 sm:w-6 opacity-80' 
                  : 'w-2.5 sm:w-3'
              } ${streakColor}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
